import React, { FC } from 'react'
import { arrowIcon, container } from './scrollButton.css'
import { Icon, classNames } from '@hermes/design-system'

export const enum ScrollButtonDirection {
  UP = 'up',
  DOWN = 'down'
}

type ScrollButtonProps = { className?: string; onClick: () => void; direction: ScrollButtonDirection }

const ScrollButton: FC<ScrollButtonProps> = ({ className, onClick, direction }) => (
  <div className={classNames(container, className)} onClick={onClick} role="button" tabIndex={0}>
    <Icon name={`arrow-${direction}`} className={arrowIcon} />
  </div>
)

export default ScrollButton
